var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"footer-logo",attrs:{"src":_vm.parent.$helper.getLinkToIlBucketFile('investing-live-logo.svg'),"alt":"investingLive"}})}
var staticRenderFns = []

export { render, staticRenderFns }